export default {
  chargebackAlert: {
    // 搜索条件相关
    searchIds: 'Search IDs',
    searchIdsPlaceholder: 'Pre-dispute ID, Transaction ID, Merchant Order Number',
    alertService: 'Service',
    alertType: 'Type',
    chargebackStatus: 'Chargeback Status',
    refundType: 'Refund Type',
    receivedTime: 'Received Time',

    // 表格字段相关 - 作者：Nemo
    preDisputeId: 'Pre-dispute ID',
    service: 'Service',
    type: 'Type',
    createdTime: 'Created Time',
    txnId: 'TXN ID',
    merchantOrderNumber: 'Merchant Order Number',
    txnAmount: 'TXN Amount',
    refundStatus: 'Refund Status',
    dueIn: 'Due in',
    viewDetail: 'View detail',
    refund: 'Refund',
    viewTransactionDetail: 'View transaction detail',

    // 状态选项
    disputed: 'Disputed',
    noChargeback: 'No chargeback filed',
    partiallyRefunded: 'Partially refunded',
    fullyRefunded: 'Fully refunded',
    notRefunded: 'Not yet refunded',

    // 详情页相关
    alertInfo: 'Alert Information',
    alertDetails: 'Alert Details',
    alertDescription: 'Alert Description',
    recommendations: 'Recommendations',
    processInfo: 'Process Information',
    processReason: 'Process Reason',
    markAsProcessed: 'Mark as Processed',
    markAsIgnored: 'Mark as Ignored',

    // 详情页顶部区域
    preDisputeAmount: 'Pre-dispute amount',
    transactionAmount: 'Transaction amount',

    // Pre-dispute details模块
    preDisputeDetails: 'Pre-dispute Details',
    amount: 'Amount',
    currency: 'Currency',
    source: 'Source',
    reasonCode: 'Reason Code',

    // Transaction details模块
    transactionDetails: 'Transaction Details',
    paymentMethod: 'Payment Method',
    chargebackId: 'Chargeback ID',
    refundRecords: 'Refund Records',
    eci: 'ECI',
    website: 'Website (DBA)',
    emailBilling: 'Email (Billing Info)',
    view: 'View',

    // 其他
    titleTip: 'Chargeback Alert Tips',
    alertDetail: 'Pre-dispute Details',
    refundId: 'Refund ID',

    // 表头提示信息 - 作者：Nemo
    dueInTooltip: 'The system will auto refund within 24 hours.',

    // 批量退款相关 - 作者：Nemo
    batchRefund: 'Batch refund',
    batchRefundCaution: 'CAUTION! You are performing Batch Refund.For partially refunded transactions, the remaining refundable amount will be submitted.',
    preDisputesSelected: 'Pre-disputes have been selected, including:',
    batchPartiallyRefunded: 'Partially refunded',
    batchNoYetRefunded: 'No yet refunded',
    batchRefundNote: 'For partially refunded transactions, the remaining refundable amount will be submitted',
    pleaseSelectData: 'Please select data to operate',
    autoRefundInitiated: 'Auto refund initiated',
    autoRefundInitiatedAt: 'Auto refund initiated at',

    // 详情页专用文案 - 去掉"预警"字样 - 作者：Nemo
    detail: {
      id: 'ID',
      service: 'Service',
      type: 'Type',
      createdTime: 'Created Time',
      receivedTime: 'Received Time',
      amount: 'Amount',
      disputeDetails: 'Pre-dispute Details',
      // 源交易信息专用文案
      txnId: 'ID',
      merchantOrderNumber: 'Merchant Order Number',
      txnTime: 'TXN Time',
      currency: 'Currency',
      paymentMethod: 'Payment Method',
      chargebackStatus: 'Chargeback Status',
      chargebackId: 'Chargeback ID',
      refundStatus: 'Refund Status',
      refundRecords: 'Refund Records',
      refundId: 'Refund ID',
      eci: 'ECI',
      website: 'Website (DBA)',
      emailBilling: 'Email (Billing Info)',
    },
  },
};
